/** Display-only Kid Hours tracking status (Current AOP program membership). */
export const KID_HOURS_TRACKING_LABEL = "Kid Hours";
export const KID_HOURS_TRACKED = "Tracked";
export const KID_HOURS_NOT_TRACKED = "Not Tracked";

/**
 * @param {boolean} tracked
 * @returns {typeof KID_HOURS_TRACKED | typeof KID_HOURS_NOT_TRACKED}
 */
export function getKidHoursTrackingStatusLabel(tracked) {
  return tracked ? KID_HOURS_TRACKED : KID_HOURS_NOT_TRACKED;
}
